import { Vehicle } from "../../objects/policy";
import DataLabel from "../typography/DataLabel";

function ReviewVehiclesList(props: any){
    const { vehicles } = props;

    return <>
        {
            (vehicles as Vehicle[]).map(function(v, i){
                return <div key={"cart-"+v.carNumber} className="container-covered-driver border border-gray-300 p-2 rounded mt-4 last:mb-6">
                    <span className="text-lg font-bold">{v.year} {v.make} {v.model}</span>
                    <div className="clear-both"></div>
                    <div className="row">
                        <div className="float-left">
                            <DataLabel>Annual Miles</DataLabel> 
                            <br/>
                            <span className="">{v.annualMileage}</span>
                        </div>
                    </div>
                    <div className="clear-both"></div>
                    <div className="clear-both"></div>
                </div>
            })            
        }
    </>;
}

export default ReviewVehiclesList